import { Component } from 'react'
import { RouteComponentProps } from 'react-router'
import { SimpleReadingLists } from 'stylewhere/api'
import { FullLoadingLayer, OperationStart, SimpleReadingStartListAndInput } from 'stylewhere/components'
import { SimpleReadingListExtensions } from 'stylewhere/extensions'
import { Router, RemoteOperation, SimpleReadingListOperationConfig, AppStore } from 'stylewhere/shared'
import { showToastError } from 'stylewhere/utils'
import { get as _get, set as _set } from 'lodash'

interface Props {
  opCode: string
}

interface State {
  loading: boolean
}

export default class SimpleReadingListStart extends Component<RouteComponentProps<Props>, State> {
  started = false
  operation = RemoteOperation.getOperationConfig<SimpleReadingListOperationConfig>(
    Router.getMatchParams(this.props).opCode
  )
  schema = SimpleReadingListExtensions.formSchema(this.operation)

  state: State = {
    loading: false
  }

  componentDidMount() {
    if (this.schema.length === 0 && !this.operation.showListOnStart) {
      this.onSubmit({}, this.operation, this.schema)
    }
  }

  onSubmit = async (formData, operation: SimpleReadingListOperationConfig, schema) => {
    if (this.started) return
    this.started = true
    try {
      this.setState({ loading: true })

      const formPostData = {}
      schema.forEach((s) => {
        const value = _get(formData, s.name)
        if (!!s.confirmValuePath && typeof value === 'object') {
          const valuePath = _get(value, s.confirmValuePath)
          _set(formPostData, s.name, valuePath)
        } else {
          _set(formPostData, s.name, value)
        }
      })

      // chiamare la start
      let operationPlaceId = AppStore.defaultWorkstation.placeId
      if (formData?.operationPlace) {
        if (typeof formData?.operationPlace === 'string') operationPlaceId = formData?.operationPlace
        else if (formData?.operationPlace.id) operationPlaceId = formData?.operationPlace.id
      }
      const postData = {
        ...formPostData,
        operationPlaceId,
        operationId: operation.id
      }
      const res = await SimpleReadingLists.start(postData)
      Router.navigate(
        '/simple-reading-list/:opCode/reading',
        { opCode: operation.code },
        { state: { formData: formData, simpleReadingList: res } }
      )
    } catch (error) {
      showToastError(error)
    } finally {
      this.started = false
      this.setState({ loading: false })
    }
  }

  onSelect = async (item) => {
    this.onSubmit(item, this.operation, {})
  }

  render() {
    if (this.operation.showListOnStart) {
      return (
        <SimpleReadingStartListAndInput operation={this.operation} onSelect={this.onSelect} onCreate={this.onSubmit} />
      )
    }
    return (
      <>
        <OperationStart
          submitPath="/simple-reading-list/:opCode/reading"
          extensions={SimpleReadingListExtensions}
          onSubmit={this.onSubmit}
          disabledAutoSubmit
        />
        {this.state.loading && <FullLoadingLayer />}
      </>
    )
  }
}
